import type {TranslationKey} from 'globalTranslations';
import {useTranslation} from '@app/hooks/use-translation';

/**
 * Returns a function that resolves translation placeholders of the form
 * `{{key}}` inside a Strapi text value using the current translation context.
 * If the value contains no placeholder the original string is returned as-is.
 */
export function useResolveTranslations(ns: string) {
	const {t} = useTranslation();

	return function resolveTranslations(value: string): string {
		if (!value || !value.includes('{{')) return value;
		return value.replace(/\{\{([^}]+)\}\}/g, (_, key: string) =>
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			t ? t(key.trim() as TranslationKey, {ns: ns as any}) : key,
		);
	};
}
